document.addEventListener("DOMContentLoaded", function () {
  // Find all service containers on the page
  const serviceContainers = document.querySelectorAll(
    ".rental-villas-services"
  );

  if (!serviceContainers.length) return;

  // Initialize each container
  serviceContainers.forEach(function (container) {
    initializeServiceContainer(container);
  });

  /**
   * Initialize a single service container
   * @param {HTMLElement} container - The service container element
   */
  function initializeServiceContainer(container) {
    const servicesGrid = container.querySelector(".rvs-services-grid");
    const loader = container.querySelector(".rvs-loader");
    const pagination = container.dataset.pagination !== "false";

    let isLoading = false;
    let hasMore = true;
    let page = parseInt(container.dataset.page, 10) || 2; // Start from 2

    // Make sure loader is positioned after the grid but initially hidden
    if (loader) {
      servicesGrid.after(loader);
      loader.style.display = hasMore && pagination ? "block" : "none";
    }

    // Intersection Observer for infinite scroll
    if (pagination && loader) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !isLoading && hasMore) {
              rvLoadPosts();
            }
          });
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0.1,
        }
      );
      observer.observe(loader);
    }

    /**
     * Load services via AJAX
     */
    function rvLoadPosts() {
      if (isLoading) return;

      isLoading = true;

      // Show loader if it exists
      if (loader && hasMore && pagination) {
        loader.style.display = "block";
      }

      // Get parameters from data attributes
      const limit = container.dataset.limit;
      const type = container.dataset.type;

      // Prepare form data
      const formData = new FormData();
      formData.append("action", "rv_load_posts");
      formData.append("nonce", rvsData.nonce);
      formData.append("limit", limit);
      formData.append("type", type);
      formData.append("page", page);

      // Send AJAX request
      fetch(rvsData.ajaxurl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success && data.data.html) {
            // Only proceed if we got HTML content
            servicesGrid.insertAdjacentHTML("beforeend", data.data.html);

            page += 1;
            hasMore = data.data.has_more;
            container.dataset.page = page;
          } else {
            hasMore = false;
          }

          // Hide loader if it exists and if no more services or if there was an error
          if (loader && (!hasMore || !pagination)) {
            loader.style.display = "none";
          }
        })
        .catch((error) => {
          hasMore = false;

          // Hide loader if it exists
          if (loader) {
            loader.style.display = "none";
          }
          console.error("Error loading services:", error);
        })
        .finally(() => {
          isLoading = false;
        });
    }
  }
});
